import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "twilioFields", "telnyxFields"];

  connect() {
    this.toggleFields();
  }

  switch() {
    this.toggleFields();
  }

  toggleFields() {
    const providerType = this.selectTarget.value;

    this.twilioFieldsTarget.classList.toggle("hidden", providerType !== "twilio");
    this.telnyxFieldsTarget.classList.toggle("hidden", providerType !== "telnyx");
  }
}
